module.exports = __webpack_public_path__ + "img/icon_cat_event.f4362ac.png";